


































import { Component, Prop, Vue } from 'vue-property-decorator'
import { PrepTaskStatus, ProductionPrepTask, ProductionPrepTaskLog } from '@/models'
import ApiClient from '@/services/api-client'
import { prepTaskStatusOption, showPrepError } from '@/utils/production-prep'

/** Status changes of a preparation task: who marked what and when (the system, for the automatic checks) */
@Component
export default class ProductionPrepTaskLogModal extends Vue {
  @Prop({ required: true }) prepId: number
  @Prop({ required: false }) task: ProductionPrepTask | null

  private logs: ProductionPrepTaskLog[] = []
  private loading = false

  statusOption(status: PrepTaskStatus) {
    return prepTaskStatusOption(status)
  }

  async load() {
    this.logs = []
    if (!this.task) return
    try {
      this.loading = true
      this.logs = await ApiClient.getProductionPrepTaskLogs(this.prepId, this.task.id)
    } catch (error) {
      showPrepError(this, error)
    } finally {
      this.loading = false
    }
  }
}
